import { FocusEvent, useMemo } from 'react';
import { css } from '@emotion/react';
import { debounce } from 'lodash-es';
import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text, useFormField, ListField } from '@frontend/design-system';

interface ReceiptSectionProps {
  emailFieldProps: ReturnType<typeof useFormField<'list'>>;
  personEmail: string | undefined;
  autoReceiptEnabled: boolean;
}
export const ReceiptSection = ({
  emailFieldProps: { onBlur, ...emailFieldProps },
  personEmail,
  autoReceiptEnabled,
}: ReceiptSectionProps) => {
  const { t } = useTranslation('payments');

  const fieldTitle =
    personEmail && autoReceiptEnabled ? (
      <Trans t={t}>
        Receipt emailed to <b>{personEmail}</b>. You can send another receipt to an additional email address here
      </Trans>
    ) : (
      t('Send a receipt to this email')
    );

  const fieldLabel = personEmail && autoReceiptEnabled ? t('Additional Email') : t('Email');

  const onBlurDebounced = useMemo(() => {
    return debounce((e?: FocusEvent<HTMLInputElement, Element>) => {
      if (typeof onBlur === 'function') {
        onBlur(e);
      }
    }, 100);
  }, []);

  return (
    <div
      css={css`
        width: 380px;
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing(1)};
        margin-top: ${theme.spacing(2)};
      `}
    >
      <Text size='large'>{fieldTitle}:</Text>
      <ListField {...emailFieldProps} onBlur={onBlurDebounced} name='email' label={fieldLabel} fieldType='email' />
    </div>
  );
};
